import {FC, useCallback, useEffect, useState} from 'react'
import {Badge, Drawer, Dropdown, notification} from 'antd'
import {DownOutlined, LogoutOutlined, SettingOutlined, ShoppingCartOutlined, UserOutlined} from '@ant-design/icons'
import {useNavigate} from 'react-router-dom'
import {useUserInfoContext} from '@/store/userInfo'
import Search from './Search'
import ChangePassword from './ChangePassword'
import {drawerWidth} from '@/config/config'
import style from '../style.module.less'
import * as api from "@/api/xsdd"
import * as utils from "@/utils/utils";

const Head: FC = () => {
    const navigator = useNavigate()
    const [hasSearch, setHasSearch] = useState(false)
    const userStore = useUserInfoContext()
    const [passwordVisible, setPasswordVisible] = useState(false)
    const {zmdddCount, } = useUserInfoContext()

    // 操作下拉
    const handleDropdown = useCallback((menu) => {
        if (menu.key === 'userCenter') {
            // 前往个人中心
            if ((userStore.baseInfo.webqxList || []).some(r => r.hmtzdz === '/center/gzt')) {
                navigator('/center/gzt')
            } else {
                navigator('/center/base/myinfo')
            }
        } else if (menu.key === 'logout') {
            userStore.clear()
            navigator('/login', {
                replace: true
            })
        } else if (menu.key === 'updatePassword') {
            setPasswordVisible(true)
        }
    }, [navigator, userStore])

    useEffect(() => {
        const computeSearch = (e) => {
            setHasSearch(window.scrollY > 100)
        }
        window.addEventListener('scroll', computeSearch)
        return () => {
            window.removeEventListener('scroll', computeSearch)
        }
    }, [])

    const handleClosePassword = useCallback(() => {
        setPasswordVisible(false)
    }, [])

    const handleMyCollection = useCallback(() => {
        navigator('/center/collection')
    }, [navigator])

    // 打开购物车
    const handleShopCar = useCallback(() => {
        navigator('/shopcar?t=' + Date.now())
    }, [navigator])

    const handleQpldd = useCallback(() => {
        navigator('/center/collaboration/qplddcx')
    }, [navigator])

    const handleSdgjdd = useCallback(() => {
        navigator('/center/collaboration/sdgjddcx')
    }, [navigator])

    const handleZmddd = useCallback(() => {
        navigator('/center/collaboration/zmdddcx?zt=待经销商确认')
    }, [navigator])


    // 检查新订单的函数
    const checkNewOrders = useCallback(async () => {
        try {
            const result = await api.xdtz({})
            if (result.success && result.count>0) {
                notification.info({
                    message: '新订单提醒',
                    description: '您有新的订单',
                    placement: 'topRight',
                    duration:290
                });
            }
        } catch (error) {
            console.error('检查新订单失败:', error);
        }
    }, []);

    // 设置定时器，每隔5分钟调用一次接口
    useEffect(() => {
        // 立即执行一次检查
        checkNewOrders();
        // 设置定时器，每隔5分钟执行一次
        const intervalId = setInterval(checkNewOrders, 5 * 60 * 1000);
        // 组件卸载时清除定时器
        return () => clearInterval(intervalId);
    }, [checkNewOrders]);

    return (
        <div className={style['head-wrap']}>
            <div className={style['head']}>
                <div className='layout-container flex align-center h-full'>
                    <div>{userStore.baseInfo.name && `【${userStore.baseInfo.name}】`}您好，欢迎来到东成精品电动工具</div>
                    {
                        hasSearch && <Search filterFlag simple className='ml-20'/>
                    }
                    <div className='flex-1'></div>
                    {
                        hasSearch && userStore.hasPermission('gwc') && (
                            <div className={`${style['head-shopcar']}`} onClick={handleShopCar}>
                                <Badge count={userStore.shopcarCount} size="small">
                                    <ShoppingCartOutlined style={{fontSize: 20}}/>
                                </Badge>
                            </div>
                        )
                    }
                    {
                        userStore.hasPermission('/center/collaboration/zmdddcx') &&
                        <Badge count={zmdddCount} size="small">
                            <div style={{color:'#fff'}} className='cursor-pointer ml-30' onClick={handleZmddd}>代发订单 </div>
                        </Badge>
                    }
                    {
                        userStore.hasPermission('/center/collaboration/qplddcx') &&
                        <div className='cursor-pointer ml-30' onClick={handleQpldd}>东成全品类订单</div>
                    }
                    {
                        userStore.hasPermission('/center/collaboration/sdgjddcx') &&
                        <div className='cursor-pointer ml-30' onClick={handleSdgjdd}>手动工具订单</div>
                    }
                    {
                        userStore.hasPermission('/center/collection') &&
                        <div className='ml-30 cursor-pointer' onClick={handleMyCollection}>我的收藏</div>
                    }
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    label: '个人中心',
                                    key: 'userCenter',
                                    icon: <UserOutlined/>
                                },
                                {
                                    label: '修改密码',
                                    key: 'updatePassword',
                                    icon: <SettingOutlined/>
                                },
                                {
                                    label: '退出登录',
                                    key: 'logout',
                                    icon: <LogoutOutlined/>
                                }
                            ],
                            onClick: handleDropdown
                        }}
                    >
                        <div className='ml-30 cursor-pointer'>
                            <span className='mr-6'>用户中心</span>
                            <DownOutlined/>
                        </div>
                    </Dropdown>
                </div>
            </div>
            <Drawer title='修改密码' width={drawerWidth} onClose={handleClosePassword} open={passwordVisible}
                    destroyOnClose className='custom-drawer'>
                <ChangePassword onCancel={handleClosePassword}/>
            </Drawer>
        </div>
    )
}

export default Head
